enum ActivityBackgroundTheme {
    Light = "light",
    Dark = "dark"
}

export default ActivityBackgroundTheme;